import filters from './filters';
import product from './product';
import lightbox from './lightbox';
import search from './search';
import quote from './quote';
import shimmer from './shimmer';
import account from './account';
import Swiper from 'swiper';

jQuery(document).ready(function ($) {

    $('.shortcode__review_large a:not([aria-label])').attr('aria-label', 'Bekijk onze klantbeoordelingen');

    filters($);
    product($);
    lightbox($);
    search($);
    quote($);
    shimmer($);
    account($);

    $(document).on('focusin pointerdown', 'form', function () {
        $('script[data-recaptcha-src]').each(function () {
            $.ajax({ url: $(this).data('recaptcha-src'), dataType: 'script', cache: true });
        }).remove();
    });


    function setMenuTop() {
        const headerHeight = $('.header__main').outerHeight();
        const menuHeight = $('.header__menu ').outerHeight() - 16;
        const wpAdmin = $('#wpadminbar ').outerHeight() ?? 0;

        var headerPx = headerHeight + menuHeight + wpAdmin - 8;

        $('.megamenu__submenu').css('top', headerPx + 'px');
    }

    setMenuTop();

    const vatToggle = $('[data-action="toggle_vat"]');
    const vatExcl = document.cookie.split('; ').includes('tds_vat=excl');

    $('body').toggleClass('is-vat-excl', vatExcl);
    vatToggle.attr('aria-checked', vatExcl);

    vatToggle.on('click', function () {
        const excl = $('body').toggleClass('is-vat-excl').hasClass('is-vat-excl');

        $(this).attr('aria-checked', excl);
        document.cookie = 'tds_vat=' + (excl ? 'excl' : 'incl') + '; path=/; max-age=31536000; SameSite=Lax';
    });

    $(window).on('resize', setMenuTop);

    var scrollTrigger = 15;

    scrollTrigger += jQuery('.header__main').outerHeight();

    jQuery(document).on('scroll', function () {

        if (jQuery(window).scrollTop() >= scrollTrigger) {

            jQuery('.header__main').addClass('is-scrolled');

        } else if (jQuery(window).scrollTop() < (scrollTrigger - 25)) { // Makes sure the bar does not bug at specific PX scrolls.

            jQuery('.header__main').removeClass('is-scrolled');

        }

    });

    $('.megamenu__nav li[data-id]').on('mouseenter', function() {
        const menuId = $(this).data('id');

        $('.megamenu__nav li').removeClass('active');
        $(this).addClass('active');

        $('.megamenu__links[data-for]').removeClass('active').hide();
        $(`.megamenu__links[data-for="${menuId}"]`).addClass('active').show();
    });

    // Functions

    let current_subject = "";

    let old_container = null;



    function resetMobileMenu() {

        // Enable main menu
        jQuery('.drawer-menu-mobile-nav').addClass('is-open');

        // Reset subs
        jQuery( '.drawer-menu-sub' ).css( 'transform', 'translateX(0)' );

    }

    // Mobile drawer

    // jQuery('[data-mobile-menu="hamburger"]').click(function(){
    //
    //     // If closing, reset the menu.
    //     if( jQuery(this).hasClass('is-open') ) {
    //
    //         jQuery('[data-mobile-menu="main"]').addClass('is-open');
    //         jQuery('.overlay').addClass('is-open');
    //
    //         resetMobileMenu();
    //
    //     }
    //
    //     // Class toggle all hamburgers.
    //     jQuery('[data-mobile-menu="hamburger"]').toggleClass('is-open');
    //
    //     // Class toggle the mobile menu.
    //     jQuery('[data-mobile-menu="menu"]').toggleClass('is-open');
    //     jQuery('.overlay').toggleClass('is-open');
    //
    // });
    //
    // jQuery('.overlay').click(function(){
    //
    //     // Class toggle all hamburgers.
    //     jQuery('[data-mobile-menu="hamburger"]').toggleClass('is-open');
    //
    //     // Class toggle the mobile menu.
    //     jQuery('[data-mobile-menu="menu"]').toggleClass('is-open');
    //     jQuery('.overlay').toggleClass('is-open');
    //
    //     resetMobileMenu();
    //
    // });
    //
    // jQuery( '.drawer-menu li.has-submenu > a' ).click(function(){
    //
    //     let val = jQuery(this).find('.categorie').text().trim();
    //     let depth = jQuery(this).find('.categorie').data('id');
    //
    //     jQuery('.categorie-' + depth ).text( val );
    //
    //     // Main menu sluiten, sub-menu geopend immers. Maakt niet uit welk niveau.
    //     jQuery('.drawer-menu-mobile-nav').removeClass('is-open');
    //
    //     // Indien diepte meer dan 0, huidige sub-menu sluiten.
    //     if ( jQuery(this).parents('.has-submenu').length > 1 ) {
    //
    //         // Move to leftt
    //         jQuery(this).parents('.drawer-menu-sub').css( 'transform', 'translateX(-100%)' );
    //
    //     } else {
    //
    //         // Move all subs to right
    //         jQuery('.drawer-menu-sub').css( 'transform', 'translateX(100%)' );
    //
    //
    //     }
    //
    //     // Slide in selected
    //     jQuery(this).next( '.drawer-menu-sub' ).css( 'transform', 'translateX(0)' );
    //
    // });
    //
    // jQuery( '.drawer-menu-return' ).click(function(){
    //
    //     // Move current back to right
    //     jQuery(this).parent('.drawer-menu-sub').css( 'transform', 'translateX(100%)' );
    //
    //     // Slide in previous
    //
    //     // Determine whether there is a parent sub
    //     if ( jQuery(this).parents('.drawer-menu-sub').length > 1 ) {
    //
    //         jQuery(this).parents('.drawer-menu-sub').eq(1).css( 'transform', 'translateX(0)' ); // Not itself, but ancestor sub.
    //
    //     } else {
    //
    //         // Slide in main
    //         jQuery('.drawer-menu-mobile-nav').addClass('is-open');
    //
    //     }
    //
    // });


    jQuery('[data-action="toggle_menu_drawer"], .overlay').click(function(){
        jQuery('[data-action="toggle_menu_drawer"], .drawer, .overlay').toggleClass('is-open');
        jQuery('.drawer__levels').removeClass('is-level-2');
    });

    jQuery('.drawer').on('click', '[data-json]', function(e) {
        e.preventDefault();
        const items = JSON.parse(jQuery(this).attr('data-json'));
        const title = jQuery(this).find('> span:first-child span:last-child').text().trim();

        let html = '';
        jQuery.each(items, function(i, item) {
            html += '<li><a href="' + item.url + '" class="u-inner-row u-gap-sb u-inner-align-center">'
                + '<span class="u-inner-row u-inner-align-center u-gap-8"><span>' + item.text + '</span></span>'
                + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'
                + '</a></li>';
        });

        jQuery('.drawer__level--2 .drawer__content-header').text(title);
        jQuery('.drawer__level--2 .drawer__content ul').html(html);
        jQuery('.drawer__levels').addClass('is-level-2');
    });

    jQuery(document).on('click', '[data-action="drawer_back"]', function() {
        jQuery('.drawer__levels').removeClass('is-level-2');
    });



    var swiper_partners = new Swiper(".partners-swiper", {
        loop: false,
        spaceBetween: 32, // Adjust the value as needed
        breakpoints: {
            0: {
                slidesPerView: 2, // Screens smaller than 458px
            },
            767: {
                slidesPerView: 6, // Screens smaller than 768px
            },
            1000: {
                slidesPerView: 8, // Screens 1000px and above
            }
        }
    });

    var product_alternative_swiper = new Swiper(".product-alternative-swiper", {
        spaceBetween: 16,
        breakpoints: {
            1024: {
                slidesPerView: 3.5,
            },
            0: {
                slidesPerView: 1.5,
            },
        },
    });

    var swiper_customers = new Swiper(".customers-swiper", {
        loop: false,
        spaceBetween: 32, // Adjust the value as needed
        breakpoints: {
            0: {
                slidesPerView: 1.5, // Screens smaller than 458px
            },
            767: {
                slidesPerView: 2.5, // Screens smaller than 768px
            },
            1000: {
                spaceBetween: 48, // Adjust the value as needed
                slidesPerView: 'auto', // Screens 1000px and above
            }
        }
    });

    var usp_carousel_swiper = new Swiper(".usp-carousel-swiper", {
        spaceBetween: 16,
        breakpoints: {
            1024: {
                slidesPerView: 3.5,
            },
            0: {
                slidesPerView: 1.5,
            },
        },
    });

    const tds__block_hero_swiper = new Swiper(".tds__blocks-hero-swiper", {
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 24,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
                autoplay: false, // disable autoplay on desktop
            },
        },
    });

    const tds__block_highlight_swiper = new Swiper(".tds__blocks-highlightswiper-swiper", {
        breakpoints: {
            0: {
                slidesPerView: '1.5',
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });

    const swiper_payment_methods = new Swiper('.footer__swiper-paymentmethods', {
        spaceBetween: 8,
        slidesPerView: 'auto',
    });

    // Account page

    jQuery('[data-action="toggle_subpages_account"]').on('click', function () {
        let value = jQuery(this).data('id');

        jQuery('[data-action="toggle_subpages_account"]').removeClass('active');
        jQuery(this).addClass('active');

        if(value == 'mijn-gegevens'){
            jQuery('.account__gegevens').show();
            jQuery('.account__bestellingen').hide();
            jQuery('.account__opgeslagen-designs').hide();
        }
        else if( value == 'opgeslagen-designs' ){
            jQuery('.account__opgeslagen-designs').show();
            jQuery('.account__bestellingen').hide();
            jQuery('.account__gegevens').hide();

        }
        else{
            jQuery('.account__opgeslagen-designs').hide();
            jQuery('.account__gegevens').hide();
            jQuery('.account__bestellingen').show();
        }
    });

    jQuery('[data-action="open_nex_subject"]').on('click', function (e) {
        let subject = jQuery(this).data('subject');

        if (current_subject === subject) {
            // If clicking the already active subject, close it
            jQuery(this).find('.service__more').removeClass('active');
            jQuery('.service__object[data-subject="' + subject + '"]').removeClass('active');
            current_subject = ""; // IMPORTANT: reset current_subject
            return;
        }

        // Otherwise, activate the new subject
        jQuery('.service__more').removeClass('active'); // Remove active from all
        jQuery(this).find('.service__more').addClass('active');

        jQuery('.service__object').removeClass('active');
        jQuery('.service__object[data-subject="' + subject + '"]').addClass('active');

        current_subject = subject; // Update current_subject
    });

    // SEO readmore

    jQuery('.readmore_button').on('click', function() {

        if (!old_container) {
            old_container = $('.limited-text');
        }

        if (old_container.hasClass('limited-text')) {
            old_container.removeClass('limited-text');
            jQuery(this).text('Lees minder');
        } else {
            // Add the class back to limit the text visibility
            old_container.addClass('limited-text');
            jQuery(this).text('Lees meer');
        }

    });

    // Readmore op de categorie-intro (.Hoofdtekst)

    $('.information .Hoofdtekst').each(function () {

        const $text = $(this);

        // Voorkom dubbele initialisatie
        if ($text.next('.hoofdtekst-readmore').length) {
            return;
        }

        $text.addClass('is-clamped');

        // Alleen een knop tonen wanneer de tekst daadwerkelijk wordt afgekapt
        if ($text[0].scrollHeight <= $text[0].clientHeight + 2) {
            $text.removeClass('is-clamped');
            return;
        }

        const $button = $('<button type="button" class="hoofdtekst-readmore">Lees meer</button>');
        $text.after($button);

        $button.on('click', function () {
            const collapsed = $text.toggleClass('is-clamped').hasClass('is-clamped');
            $button.text(collapsed ? 'Lees meer' : 'Lees minder');
        });

    });

    // Readmore op de categorie-omschrijving (archief)

    $('.wc__archive-product-description').each(function () {

        const $text = $(this);

        // Niets doen wanneer de omschrijving leeg is of al is geïnitialiseerd
        if (!$.trim($text.text()).length) {
            return;
        }
        if ($text.next('.wc__archive-product-description-readmore').length) {
            return;
        }

        $text.addClass('is-clamped');

        // Alleen een knop tonen wanneer de tekst daadwerkelijk wordt afgekapt
        if ($text[0].scrollHeight <= $text[0].clientHeight + 2) {
            $text.removeClass('is-clamped');
            return;
        }

        const $button = $('<button type="button" class="wc__archive-product-description-readmore">Lees meer</button>');
        $text.after($button);

        const ANIMATION_SPEED = 350;
        let isAnimating = false;

        $button.on('click', function () {

            if (isAnimating) {
                return;
            }
            isAnimating = true;

            const isCollapsed = $text.hasClass('is-clamped');

            // Beginhoogte vastzetten en het clamp-effect uitzetten zodat we
            // vloeiend tussen de ingeklapte en volledige hoogte kunnen animeren.
            const startHeight = $text.height();
            $text.removeClass('is-clamped').css({ height: startHeight, overflow: 'hidden' });

            let targetHeight;

            if (isCollapsed) {
                // Uitklappen: animeren naar de volledige hoogte
                targetHeight = $text.css('height', 'auto').height();
                $button.text('Lees minder');
            } else {
                // Inklappen: hoogte van de ingeklapte staat opmeten als doel
                targetHeight = $text.addClass('is-clamped').css('height', '').height();
                $text.removeClass('is-clamped');
                $button.text('Lees meer');
            }

            $text.css('height', startHeight).stop().animate({ height: targetHeight }, ANIMATION_SPEED, function () {
                if (isCollapsed) {
                    // Volledig uitgeklapt: inline hoogte weer loslaten
                    $text.css({ height: '', overflow: '' });
                } else {
                    // Terug naar de ingeklapte staat met clamp/ellipsis
                    $text.addClass('is-clamped').css({ height: '', overflow: '' });
                }
                isAnimating = false;
            });

        });

    });

    jQuery('[data-action="check_giftvoucher"]').on('click', function (e) {
        let couponCode = $('#giftvoucher_input').val();

        $('#errormessage').hide();

        // giftvoucher_input (trhis is now a form) and i want to take out the input name="code" as val that iws my new couponCode
        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'check_coupon_balance',
                coupon_code: couponCode
            },
            success: function(response) {
                if (response.success) {
                    $('#amount_giftvoucher').val('€'+ response.data.amount);

                    var dateString = response.data.expiredate.date;
                    var formattedDate = dateString.split(' ')[0];

                    $('#amount_expiredate').val(formattedDate);
                }
                else{
                    $('#errormessage').show();
                }
            },
        });

    });

    // Search function

    if (window.location.pathname === "/blackfriday/") {

        if (blackFridayEndDate) {
            const fd = new FlipDown(new Date(blackFridayEndDate).getTime() / 1000, {
                theme: 'light',
                headings: ["Dagen", "Uren", "Minuten", "Seconden"],
            }).start();
        }
    }


    $('.satisfactionhero__title').each(function () {

        const $el = $(this);
        const originalText = $.trim($el.text());
        const match = originalText.match(/[\d.,]+/);

        if (!match || !('IntersectionObserver' in window)) return;

        const target = parseInt(match[0].replace(/[.,]/g, ''), 10);

        if (!target) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const prefix = originalText.slice(0, match.index);
        const suffix = originalText.slice(match.index + match[0].length);
        const duration = 2000;

        function formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }

        $el.text(prefix + '0' + suffix);

        const observer = new IntersectionObserver(function (entries) {

            entries.forEach(function (entry) {

                if (!entry.isIntersecting) return;

                observer.unobserve(entry.target);

                const start = performance.now();

                function tick(now) {
                    const progress = Math.min((now - start) / duration, 1);
                    const eased = 1 - Math.pow(1 - progress, 4);

                    $el.text(prefix + formatNumber(Math.round(target * eased)) + suffix);

                    if (progress < 1) requestAnimationFrame(tick);
                }

                requestAnimationFrame(tick);

            });

        }, { threshold: 0.4 });

        observer.observe(this);

    });

});

